import React from "react";
import { NavLink } from "react-router-dom";
import "./MobileNav.scss";

export default function MobileNav() {
  return (
    <div className="mobile-bottom-nav">
      <NavLink
        to="/"
        end
        className={({ isActive }) =>
          isActive ? "nav-item active" : "nav-item"
        }
      >
        <span className="nav-icon"></span>
        <span className="nav-text">Home</span>
      </NavLink>

      <NavLink
        to="/expertview"
        className={({ isActive }) =>
          isActive ? "nav-item active" : "nav-item"
        }
      >
        <span className="nav-icon"></span>
        <span className="nav-text">Experts</span>
      </NavLink>

      {/*
      <NavLink
        to="/alerts"
        className={({ isActive }) =>
          isActive ? "nav-item active" : "nav-item"
        }
      >
        <span className="nav-icon">🔔</span>
        <span className="nav-text">Alerts</span>
      </NavLink>

      <NavLink
        to="/profile"
        className="nav-item profile"
      >
        <img src="https://i.pravatar.cc/40" alt="profile" />
      </NavLink>
      */}
    </div>
  );
}
